module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_MICROFIBER _mobile.bc48d65f.jpg";